var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeat = function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.352 12.48a.6.6 0 0 1 .6.599v1.04a4.76 4.76 0 0 1-4.757 4.755H4.098l3.131 3.132a.6.6 0 0 1-.848.848l-4.156-4.156a.6.6 0 0 1-.14-.623q.006-.016.01-.031a.6.6 0 0 1 .13-.195l4.156-4.155a.6.6 0 0 1 .848.848l-3.132 3.132h13.098a3.56 3.56 0 0 0 3.557-3.556V13.08a.6.6 0 0 1 .6-.6m-4.58-11.253a.6.6 0 0 1 .847 0l4.156 4.155a.6.6 0 0 1 0 .848l-4.156 4.157a.6.6 0 1 1-.848-.849l3.13-3.132H6.806a3.557 3.557 0 0 0-3.557 3.557v1.039a.6.6 0 0 1-1.2 0v-1.04a4.756 4.756 0 0 1 4.757-4.755h13.097l-3.131-3.133a.6.6 0 0 1 0-.847"
  })));
};
export default SvgRepeat;